import { Grid, GridItem, H3, H4, Text } from '@bigcommerce/big-design';
import { useFormatCurrency } from '../hooks/useFormatCurrency';

function ShippingChargeGridItems({ shippingCharge }) {
	if (shippingCharge <= 0) return null;

	return (
		<>
			<GridItem border="box" paddingLeft="xSmall" padding="xxSmall">
				<H4 marginBottom="none">Shipping</H4>
			</GridItem>
			<GridItem border="box" paddingLeft="xSmall" padding="xxSmall">
				<Text>{useFormatCurrency(shippingCharge)}</Text>
			</GridItem>
		</>
	);
}

export default function OrderTotals({
	orderTotal,
	shippingCharge,
	regularSubTotal,
	saleSubtotal,
}) {
	return (
		<Grid gridColumns="repeat(2, 1fr)" gridGap="0" paddingTop="xLarge">
			<GridItem border="box" paddingLeft="xSmall" padding="xxSmall">
				<H4 marginBottom="none">Subtotal</H4>
			</GridItem>
			<GridItem border="box" paddingLeft="xSmall" padding="xxSmall">
				<Text>{useFormatCurrency(regularSubTotal)}</Text>
			</GridItem>
			<GridItem border="box" paddingLeft="xSmall" padding="xxSmall">
				<H4 marginBottom="none">Discount</H4>
			</GridItem>
			<GridItem border="box" paddingLeft="xSmall" padding="xxSmall">
				<Text>{useFormatCurrency(saleSubtotal - regularSubTotal)}</Text>
			</GridItem>
			<GridItem border="box" paddingLeft="xSmall" padding="xxSmall">
				<H4 marginBottom="none">Sale Subtotal</H4>
			</GridItem>
			<GridItem border="box" paddingLeft="xSmall" padding="xxSmall">
				<Text>{useFormatCurrency(saleSubtotal)}</Text>
			</GridItem>
			<ShippingChargeGridItems shippingCharge={shippingCharge} />
			<GridItem border="box" paddingLeft="xSmall" padding="xxSmall">
				<H3 marginBottom="none">Order Total</H3>
			</GridItem>
			<GridItem border="box" paddingLeft="xSmall" padding="xxSmall">
				<Text>{useFormatCurrency(orderTotal)}</Text>
			</GridItem>
		</Grid>
	);
}
